import React from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const TeacherForm = ({ form, isEditMode = false }) => {
  const role = Form.useWatch('role', form);

  return (
    <Form form={form} layout="vertical" name="teacher_form">
      <Form.Item name="name" label="姓名" rules={[{ required: true, message: '请输入教师姓名' }]}>
        <Input />
      </Form.Item>
      <Form.Item name="account" label="账号" rules={[{ required: true, message: '请输入教师账号' }]} hidden={isEditMode}>
        <Input disabled={isEditMode} />
      </Form.Item>
      <Form.Item name="role" label="角色" rules={[{ required: true, message: '请选择角色' }]} initialValue="CLASS_TEACHER">
        <Select aria-label="选择角色">
          <Option value="CLASS_TEACHER">普通教师</Option>
          <Option value="ADMIN">管理员</Option>
          <Option value="TEACHING_ADMIN">教学管理员</Option>
          <Option value="LOGISTICS_ADMIN">后勤管理员</Option>
          <Option value="LOGISTICS_TEACHER">后勤生活老师</Option>
        </Select>
      </Form.Item>
      {role === 'LOGISTICS_TEACHER' && (
        <Form.Item name="gender" label="性别" rules={[{ required: true, message: '请选择生活老师性别' }]}>
          <Select placeholder="请选择性别" options={[{ label: '男', value: '男' }, { label: '女', value: '女' }]} />
        </Form.Item>
      )}
      {!isEditMode && (
        <Form.Item name="password" label="初始密码" rules={[{ required: true, message: '请输入初始密码' }]}>
          <Input.Password />
        </Form.Item>
      )}
    </Form>
  );
};

export default TeacherForm;
